<template>
  <div>
  <van-form @submit="onSubmit" @failed="onFailed">
    <van-divider contentPosition="center" >
      下户面谈-小区情况
    </van-divider>
    <van-field
            clearable
            label="小区名称"
            name="estateName"
            placeholder="请输入小区名称"
            type="string"
            :readonly="isReadOnly"
            v-model="form.estateName"
    />
    <van-field
            clearable
            label="小区情况"
            required
            name="houseEstateStatus"
            placeholder="请选择小区情况"
            right-icon="records"
            v-model="form.houseEstateStatus"
            :rules="[{ required: true, message: '请选择小区情况' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseEstateStatus')"
    />
    <van-field
            clearable
            label="交通情况"
            name="houseRafficSituation"
            type="textarea"
            required
            v-model="form.houseRafficSituation"
            :rules="[{ required: true, message: '请输入交通情况' }]"
            :readonly="isReadOnly"
    />
    <van-field
            clearable
            label="所在楼层"
            name="floor"
            placeholder="所在楼层"
            type="number"
            required
            :rules="[{ required: true, message: '请填写所在楼层' }]"
            :readonly="isReadOnly"
            v-model="form.floor"
    />
    <van-field
            clearable
            label="总楼层"
            name="totalFloor"
            placeholder="总楼层"
            type="number"
            required
            :rules="[{ required: true, message: '请填写总楼层' }]"
            :readonly="isReadOnly"
            v-model="form.totalFloor"
    />
    <van-field
            clearable
            label="是否顶楼"
            name="houseAtTop"
            placeholder="是否顶楼"
            right-icon="records"
            v-model="form.houseAtTop"
            required
            :rules="[{ required: true, message: '请选择是否顶楼' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseAtTop')"
    />
    <van-field
            clearable
            label="有无电梯"
            name="houseElevatorStruct"
            placeholder="有无电梯"
            right-icon="records"
            required
            v-model="form.houseElevatorStruct"
            :rules="[{ required: true, message: '请选择有无电梯' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseElevatorStruct')"
    />
    <van-field
            clearable
            label="正面配套"
            name="houseEnvPositive"
            placeholder="正面配套"
            right-icon="records"
            required
            v-model="form.houseEnvPositive"
            :rules="[{ required: true, message: '请选择正面配套' }]"
            :readonly="isReadOnly"
            @click-right-icon="showMuliplePopup('houseEnvPositive')"
    />
    <van-field
            clearable
            label="负面配套"
            name="houseEnvPositive"
            placeholder="负面配套"
            right-icon="records"
            required
            v-model="form.houseEnvNegative"
            :rules="[{ required: true, message: '请选择负面配套' }]"
            :readonly="isReadOnly"
            @click-right-icon="showMuliplePopup('houseEnvNegative')"
    />
    <van-divider contentPosition="center" >
      下户面谈-房产使用情况
    </van-divider>
    <van-field
            clearable
            label="房产用途"
            name="housePurpose"
            placeholder="请输入房产证上房产用途"
            v-model="form.housePurpose"
            :readonly="isReadOnly"
            required
            :rules="[{ required: true, message: '请输入房产证上房产用途' }]"
    />
    <van-field
            clearable
            label="是否出租"
            name="lease"
            placeholder="是否出租"
            right-icon="records"
            v-model="form.lease"
            :rules="[{ required: true, message: '请选择是否出租' }]"
            :readonly="isReadOnly"
            required
            @click-right-icon="showPopup('leaseMap')"
    />
    <van-field
            clearable
            label="租期(月)"
            name="houseLeaseTerm"
            placeholder="租期"
            type="number"
            :readonly="isReadOnly"
            v-model="form.houseLeaseTerm"
            v-show="form.lease === 'yes'"
    />
    <van-field
            clearable
            label="租金(元/月)"
            name="houseRental"
            placeholder="租期"
            type="number"
            :readonly="isReadOnly"
            v-model="form.houseRental"
            v-show="form.lease === 'yes'"
    />
    <van-field
            clearable
            label="装修情况"
            name="decorate"
            placeholder="装修情况"
            right-icon="records"
            v-model="form.decorate"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('decorate')"
    />
    <van-field
            clearable
            label="房屋格局"
            name="houseSpaceRoom"
            placeholder="房屋格局"
            :readonly="isReadOnly"
            v-model="form.houseSpaceRoom"
    />
    <van-field
            clearable
            label="朝向"
            name="toward"
            placeholder="朝向"
            right-icon="records"
            v-model="form.toward"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('toward')"
    />
    <van-field
            clearable
            label="是否有改造"
            name="estateCertificate"
            placeholder="是否有改造"
            right-icon="records"
            v-model="form.estateCertificate"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('estateCertificate')"
    />
    <van-field
            clearable
            label="结构异常"
            name="houseStructChange"
            placeholder="结构异常"
            right-icon="records"
            v-model="form.houseStructChange"
            :rules="[{ required: true, message: '请选择' }]"
            :readonly="isReadOnly"
            required
            @click-right-icon="showPopup('houseStructChange')"
    />
    <van-field v-show="isStructure"
            clearable
            label="异常说明"
            name="houseStructNote"
            placeholder="异常说明"
            :readonly="isReadOnly"
            v-model="form.houseStructNote"
    />
    <van-field
            clearable
            label="是否有暗房"
            name="houseNotWindowRoom"
            placeholder="是否有暗房"
            right-icon="records"
            v-model="form.houseNotWindowRoom"
            :rules="[{ required: true, message: '请选择' }]"
            :readonly="isReadOnly"
            required
            @click-right-icon="showPopup('houseNotWindowRoom')"
    />
    <van-field
            clearable
            label="有无未成年/70岁以上老人"
            name="youngOrOld"
            placeholder="有无未成年/70岁以上老人"
            right-icon="records"
            v-model="form.youngOrOld"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('youngOrOld')"
    />
    <van-field
            clearable
            label="有无卧床病人"
            name="patient"
            placeholder="请选择"
            right-icon="records"
            v-model="form.patient"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('patient')"
    />
    <van-divider contentPosition="center" >
      下户面谈-中介价格
    </van-divider>
    <van-field
            clearable
            label="快出价(万)"
            name="urgentSalePrice"
            placeholder="快出价"
            type="number"
            :readonly="isReadOnly"
            v-model="form.urgentSalePrice"
    />
    <van-field
            clearable
            label="小区挂牌均价(万/平方米)"
            name="listingPrice"
            placeholder="小区挂牌均价"
            type="number"
            required
            :rules="[{ required: true, message: '请输入' }]"
            :readonly="isReadOnly"
            v-model="form.listingPrice"
    />
    <van-field
            clearable
            label="小区近期成交价(万/平方米)"
            name="recentTransactionPrice"
            placeholder="小区近期成交价"
            type="number"
            required
            :rules="[{ required: true, message: '请输入' }]"
            :readonly="isReadOnly"
            v-model="form.recentTransactionPrice"
    />
    <van-field
            clearable
            label="成交周期(月)"
            name="transactionCycle"
            placeholder="成交周期"
            type="number"
            :readonly="isReadOnly"
            v-model="form.transactionCycle"
    />
    <van-field
            clearable
            label="小区同户型挂牌量(套)"
            name="salesVolume"
            placeholder="小区同户型挂牌量"
            type="number"
            :readonly="isReadOnly"
            v-model="form.salesVolume"
    />
    <van-field
            clearable
            label="中介电话"
            name="urgentSalePrice"
            placeholder="中介电话"
            :readonly="isReadOnly"
            v-model="form.agencyPhone"
    />
    <van-divider contentPosition="center" >
      下户面谈-房产其他信息
    </van-divider>
    <van-field
            clearable
            label="产权是否清晰"
            name="propertyClear"
            placeholder="产权是否清晰"
            right-icon="records"
            v-model="form.propertyClear"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('propertyClear')"
    />
    <van-field
            clearable
            label="房产取得方式"
            name="estateInherit"
            placeholder="房产取得方式"
            right-icon="records"
            v-model="form.estateInherit"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('estateInherit')"
    />
    <van-field
            clearable
            label="房产取得节点"
            name="houseGetNode"
            placeholder="房产取得节点"
            right-icon="records"
            v-model="form.houseGetNode"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseGetNode')"
    />
    <van-field
            clearable
            label="有无查封记录"
            name="sealUp"
            placeholder="有无查封记录"
            right-icon="records"
            v-model="form.sealUp"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('sealUp')"
    />
    <van-field
            clearable
            label="查封原因"
            name="urgentSalePrice"
            placeholder="请输入查封原因"
            :readonly="isReadOnly"
            required
            v-model="form.sealUpReason"
            v-show="form.sealUp === '有'"
    />

    <van-field
            clearable
            label="解封时间"
            name="unSealDate"
            v-model="form.unSealDate"
            :readonly="isReadOnly"
            placeholder="解封时间"
            right-icon="records"
            @click-right-icon="showDatePopup('unSealDate')"
            v-show="form.sealUp === '有'"
    />
    <van-field
        clearable
        label="位置分类目录"
        name="locationCatalog"
        v-model="form.locationCatalog"
        :readonly="isReadOnly"
        placeholder="请选择位置分类目录"
        right-icon="records"
        @click-right-icon="showPopup('locationCatalog')"
    >
    </van-field>

    <van-field
            clearable
            label="一房两证/打通房"
            name="estateCertificate"
            placeholder="一房两证/打通房"
            right-icon="records"
            v-model="form.estateCertificate"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('estateCertificate')"
    />

    <van-field
            clearable
            label="包含户口"
            name="houseFamilyRegister"
            placeholder="包含户口"
            right-icon="records"
            required
            v-model="form.houseFamilyRegister"
            :rules="[{ required: true, message: '请选择' }]"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseFamilyRegister')"
    />

    <van-field
            clearable
            label="是否唯一住房"
            name="houseOnlyResidence"
            placeholder="是否唯一住房"
            right-icon="records"
            v-model="form.houseOnlyResidence"
            :readonly="isReadOnly"
            @click-right-icon="showPopup('houseOnlyResidence')"
    />
    <van-field
            clearable
            label="其他房产"
            name="otherHouseAddress"
            :rules="[{ required: true, message: '请填写其他房产' }]"
            :readonly="isReadOnly"
            placeholder="其他房产"
            v-model="form.otherHouseAddress"
            v-show="form.houseOnlyResidence === '否'"
    />

    <div style="margin: 16px;" >
      <van-row gutter="20">
        <van-col span="12" v-if="!isReadOnly">
        <van-button round block :loading="loading" type="info" native-type="submit" size="small">
          保存
        </van-button>
        </van-col>
        <van-col :span="!isReadOnly?12:24">
        <van-button round block @click="goBack" size="small">
          返回
        </van-button>
        </van-col>
      </van-row>

    </div>
  </van-form>

  <van-popup position="bottom" v-model="popupShow" :overlay="true">
    <van-picker title="请选择" show-toolbar :columns="columns"
                @confirm="onConfirm"
                @cancel="popupShow=false"/>

  </van-popup>

  <van-popup position="bottom" v-model="popupMultipleShow" :overlay="true">
    <van-picker title="多选"
                show-toolbar
                cancel-button-text="关闭"
                confirm-button-text="选择"
                :columns="multipleColumns"
                @confirm="onMultipleSelect"
                @cancel="onMultipleConfirm"/>

  </van-popup>

    <van-popup
            v-model="showDatePicker"
            position="bottom">
      <van-datetime-picker
              type="date"
              @confirm="confirmDate"
              :min-date="minDate"
              @cancel="showDatePicker=false"
      />
    </van-popup>

  </div>

</template>

<script>

import {dictData} from "@/vue/utils/interviewData";
import { cloneDeep } from 'lodash'
import Vue from "vue";
import moment from 'moment'
import {getHouseInfo, saveCustomerHouse} from "../../../../../api/loanInfo";
import {eventBus} from '@/vue/utils/eventBus'
import Dialog from "vant/lib/dialog";
export default {
  name: 'warrant-mortgage',
  props: {
    mortgageId: {
      type: String,
      default: ''
    },
    isReadOnly:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    'form.houseStructChange'(value) {
      if (value === '是') {
        this.isStructure = true
      } else {
        this.form.houseStructNote = ''
        this.isStructure = false
      }
    },


  },
  data() {
    return {
      // 对应的字段名称
      field: undefined,
      columns: [],
      isStructure:false,
      multipleColumns: [],
      // 单选
      popupShow: false,
      // 多选
      popupMultipleShow: false,
      // 时间选择
      showDatePicker: false,
      loading:false,
      minDate: new Date(1980, 0, 1),
      form: {
        estateName: undefined,
        houseEstateStatus: undefined,
        houseRafficSituation: undefined,
        floor: undefined,
        totalFloor: undefined,
        houseAtTop: undefined,
        houseElevatorStruct: undefined,
        houseEnvPositive: undefined,
        houseEnvNegative: undefined,
        housePurpose: undefined,
        lease: undefined,
        houseLeaseTerm: undefined,
        houseRental: undefined,
        decorate: undefined,
        houseSpaceRoom: undefined,
        toward: undefined,
        estateCertificate: undefined,
        houseStructChange: undefined,
        houseStructNote: undefined,
        houseNotWindowRoom: undefined,
        youngOrOld: undefined,
        patient: undefined,
        urgentSalePrice: undefined,
        listingPrice: undefined,
        recentTransactionPrice: undefined,
        transactionCycle: undefined,
        salesVolume: undefined,
        agencyPhone: undefined,
        propertyClear: undefined,
        estateInherit: undefined,
        houseGetNode: undefined,
        sealUp: undefined,
        sealUpReason: undefined,
        unSealDate: undefined,
        houseFamilyRegister:undefined,
        houseWorldunionPrice: undefined,
        houseAgentPrice: undefined,
        houseCurrentTradePrice: undefined,
        houseTotalPrice: undefined,
        houseUseingStatus: undefined,
        houseCohabitantRelation: undefined,
        houseOnlyResidence:undefined,
        otherHouseAddress:undefined,
      }
    }
  },
  mounted() {
    let self = this
    this.loadHouses()
  },
  destroyed() {
  },
  methods: {
    goBack() {
      console.log('goBackToInterviewEdit')
      eventBus.$emit('goBackToInterviewEdit')
    },
    loadHouses() {
      const self=this
      getHouseInfo(this.mortgageId).then(res => {
        if (res.success) {
          this.form = res.data
          this.form.lease = dictData['leaseMap'][this.form.lease]
          this.form.decorate = dictData['decorateMap'][this.form.decorate]
          this.form.toward = dictData['towardMap'][this.form.toward]
          this.form.houseOnlyResidence = dictData['houseOnlyResidenceMap'][this.form.houseOnlyResidence]
          this.form.houseGetNode= dictData['houseGetNodeMap'][this.form.houseGetNode]
          this.form.unSealDate != null ? (this.form.unSealDate = moment(this.form.unSealDate).format('YYYY-MM-DD')) :
          setTimeout(() => {
            this.form.unSealDate=null
          }, 200)

        }
      })
    },
    // 确认选择
    onMultipleConfirm(value) {
      //this.form[this.field] = value
      this.popupMultipleShow = false
    },
    // 确认选择
    onMultipleSelect(value) {
      let _value = this.form[this.field]
      console.log(_value)
      if (_value) {
        this.form[this.field] = _value + ',' + value
      } else {
        this.form[this.field] = value
      }
      this.$toast('当前选择：' + this.form[this.field])
    },
    // 确认选择
    onConfirm(value) {
      this.form[this.field] = value
      this.popupShow = false
    },
    // 激活弹出选择器
    showPopup(value) {
      if (!this.isReadOnly) {
        this.field = value
        this.columns = dictData[value]
        this.popupShow = true
      }
    },
    // 激活弹出多选选择器
    showMuliplePopup(value) {
      // 赋值对应字段
      if (!this.isReadOnly) {
        this.field = value
        this.multipleColumns = dictData[value]
        this.popupMultipleShow = true
      }
    },
    // 激活弹出时间选择器
    showDatePopup(value) {
      // 赋值对应字段
      if (!this.isReadOnly) {
        this.field = value
        this.showDatePicker = true
      }

    },
    confirmDate(value) {
      this.form[this.field] = value.toLocaleString()
      this.showDatePicker = false
    },

    // 提交
    onSubmit(values) {
      const self=this
      if (!this.loading) {
        this.loading = true
        let params = cloneDeep(this.form)
        if (params.decorate) {
          params.decorate=self.findKeyByValue(dictData["decorateMap"],params.decorate)
        }
        if (params.lease) {
          params.lease=self.findKeyByValue(dictData["leaseMap"],params.lease)
        }
        if (params.toward) {
          params.toward=self.findKeyByValue(dictData["towardMap"],params.toward)
        }
        if (params.houseOnlyResidence) {
          params.houseOnlyResidence=self.findKeyByValue(dictData["houseOnlyResidenceMap"],params.houseOnlyResidenc)
        }
        if(params.unSealDate){
          params.unSealDate=moment(params.unSealDate).format('YYYY-MM-DD')
        }
        if(params.houseGetNode){
          params.houseGetNode=self.findKeyByValue(dictData["houseGetNodeMap"],params.houseGetNode)
        }
        // 保存
        saveCustomerHouse(params).then(res => {
          Dialog.alert({
            message: res.msg
          })
          this.loading = false
          self.goBack()
        }).finally(() => {
          this.loading = false
        })
      }

    },
    onFailed(errorInfo) {

    },
    findKeyByValue(map, targetValue) {
      // 检查 map 是否是 Object 类型
      if (typeof map === "object" && !Array.isArray(map) && map !== null) {
        for (const [key, value] of Object.entries(map)) {
          if (value === targetValue) {
            return key; // 找到匹配的 key 后返回
          }
        }
      } else if (map instanceof Map) {
        // 如果是 Map 类型
        for (const [key, value] of map) {
          if (value === targetValue) {
            return key; // 找到匹配的 key 后返回
          }
        }
      }
    // 没有匹配的 key
    return undefined;
  }

}

}
</script>

<style scoped>
.htmlContent {
  overflow: auto;
}
</style>
